import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '~components/skeleton';
import LoaderCard from '../loader-card';
import './style.scss';
import '../style.scss';

function TeamLoader({ isMobile }) {
    return (
        <div className="team-loader team">
            <div className="team-list">
                <h3>
                    <Skeleton
                        width={isMobile ? 80 : 105}
                        fontSize={isMobile ? 18 : 24}
                        lineHeight={isMobile ? 24 : 40}
                    />
                </h3>

                <LoaderCard isMobile={isMobile} />
                <LoaderCard isMobile={isMobile} />
                <LoaderCard isMobile={isMobile} />
                <LoaderCard isMobile={isMobile} />
                <LoaderCard isMobile={isMobile} />
                <LoaderCard isMobile={isMobile} />
            </div>
        </div>
    );
}

TeamLoader.propTypes = {
    isMobile: PropTypes.bool.isRequired,
}

export default TeamLoader;
export { TeamLoader };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/tab-team/team/loader/index.js